module.exports = "/_next/static/images/the-sun-badge-a1994018b104dae29a5eb07e281fa528.jpg";